import * as React from 'react';
export const associatedbankSvg = React.forwardRef(
  function associatedbankSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: 'none',
          fillRule: 'evenodd',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#0BB047',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          d: 'm16.43 14.84-9.51 6.82V16.3l9.51-6.79V4.32l8.65 6.83v5.32L16.43 9.7v5.01l8.65 6.79v5.36l-8.65-6.82v-5.19zm0 5.92v6.92H6.92l9.51-6.92z',
        }),
      ),
    );
  },
);
associatedbankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var associatedbank = {
  category: 'brand',
  colorable: false,
  name: 'associatedbank',
  svg: associatedbankSvg,
};
